import { NgModule } from '@angular/core';

import { DatatableKeyboardDirective } from './datatable-keyboard.directive';

/**
 * Exports {@link DatatableKeyboardDirective} so any feature module that uses
 * angular-6-datatable can import it and make its sortable headers / pagination
 * keyboard accessible.
 */
@NgModule({
  declarations: [DatatableKeyboardDirective],
  exports: [DatatableKeyboardDirective]
})
export class DatatableKeyboardModule {
}